import { RoutesConfiguration } from '@components/RouterOutlet';
import { User } from '@api/types.generated';

export const hasUserPermission = (user: User | null, permissions: boolean): boolean => {
  if (!user) {
    return false;
  }

  if (user.isAdmin) {
    return true;
  }

  return permissions;
};

type ArrayItemWithPermissions = { permittedRoles: boolean };

export const filterPermitted = <T extends ArrayItemWithPermissions>(routes: T[], user?: User): T[] => {
  if (!user) {
    return [];
  }
  return routes.filter((route) => hasUserPermission(user, route.permittedRoles));
};

export const permittedRoutes = (routesConf: RoutesConfiguration, user: User) => filterPermitted(routesConf, user);
